"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class AnalysisValidation extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => String),
    (0, base_models_1.Docs)({ example: ['No match: none of the campaign groups match with the segments of the customer'], description: 'Reasons why there was no match. Is empty when `doesMatch` is true.' }),
    tslib_1.__metadata("design:type", Array)
], AnalysisValidation.prototype, "reasons", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    (0, base_models_1.Docs)({ example: true, description: 'Whether or not the campaign and profile match.' }),
    tslib_1.__metadata("design:type", Boolean)
], AnalysisValidation.prototype, "doesMatch", void 0);
exports.default = AnalysisValidation;
